import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { usePumpSeries } from "../../../hooks/usePumps";
import loaderIcon from "../../../images/icons/loader.svg";
import LazyImage from "../../common/LazyImage";

import { selectionBase } from "../../../utils/routes";

const PumpsRange = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = usePumpSeries();

  // Очищаем состояние навигации после отображения ошибки
  useEffect(() => {
    if (location.state?.error) {
      const timer = setTimeout(() => {
        navigate(location.pathname, { replace: true, state: {} });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [location.state?.error, navigate, location.pathname]);

  // Функция для получения пути к изображению серии
  const getSeriesImagePath = (seriesName) => {
    try {
      return require(`../../../images/pump/${seriesName}.jpg`);
    } catch (e) {
      return null;
    }
  };

  if (isLoading) {
    return (
      <div className="loader">
        <img src={loaderIcon} alt="loader" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="page-width">
        Ошибка: {error?.message || "Ошибка загрузки списка серий"}
      </div>
    );
  }

  const items = data || [];

  return (
    <div className="pump-series page-width_large">
      <div className="pump-series-grid">
        {items.map((series) => (
          <Link
            to={`${selectionBase()}/${series.id}`}
            key={series.id}
            className="pump-series-card"
            state={{
              seriesName: series.name,
              seriesData: {
                id: series.id,
                name: series.name,
                description: series.description,
                P_CurveName: series.P_CurveName,
                for_drainage: series.for_drainage,
                has_control: series.has_control,
                has_count: series.has_count,
                wet_rotor: series.wet_rotor,
              },
            }}
          >
            {getSeriesImagePath(series.name) && (
              <LazyImage
                src={getSeriesImagePath(series.name)}
                alt={`Серия ${series.name}`}
                className="series-image-container"
                maxWidth="120px"
                maxHeight="180px"
              />
            )}
            <div className="series-info">
              <h3>{series.name}</h3>
              <p>{series.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PumpsRange;
